import { render, staticRenderFns } from "./ScanAddOrEdit.vue?vue&type=template&id=5df913ca"
import script from "./ScanAddOrEdit.vue?vue&type=script&lang=js"
export * from "./ScanAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./ScanAddOrEdit.vue?vue&type=style&index=0&id=5df913ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports